import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IsGranted} from '../../../../decorator/is-granted';
import {MetaTitle} from '../../../../decorator/meta-title';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {LoaderService} from '../../../../services/loader/loader.service';
import {LandingPageService} from '../../../../services/landing-page/landing-page.service';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-decrypt-tool',
  imports: [
    ReactiveFormsModule,
    NgClass
  ],
  templateUrl: './decrypt-tool.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './decrypt-tool.component.scss',
})
@IsGranted(['DECRYPT_TOOL_VIEW'])
@MetaTitle('Decrypt Tool')
export class DecryptToolComponent implements OnInit {
  form = new FormGroup({
    value: new FormControl('', Validators.required),
  });

  results: any[] | null = null;

  constructor(
    private loader: LoaderService,
    private landingPageService: LandingPageService
  ) {
  }

  ngOnInit(): void {
    // this.form.get('value')?.setValue('https://digikod-lu.slack.com/archives/D0842HV3KJL/p1785149001636209?gender=Ihfi0ujQG1jgGNBD9pwdOQ&firstname=XNGFYqOQI1mCY9mef0aJbw&email=pLzAKP8zqEUpYoH28F1yv8j9K_xKUsCp-IPaS296920&birthdate=p2VxO__Apjj8rLc8mUFQt0A&country=fMyovIjbrhY5hA7EGvUVkA&sourcetype=w48d3dncNf6iuq6RiZHq_w&sourcedetails=w48d3dncNf6iuq6RiZHq_w&cid=SMza45vwfktFYhcRv36lWw');
    // this.form.get('value')?.setValue('XNGFYqOQI1mCY9mef0aJbw');
  }

  onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    const params: any = this.form.value;

    if (params.value) {
      this.loader.startLoading();

      this.landingPageService.decrypt(params.value).subscribe((results: any[]) => {
        this.results = results;

        this.loader.stopLoading();
      });
    }
  }

  getClass(result: any): string {
    return 'decrypt-' + (result.decrypted ? 'success' : 'failed');
  }
}
